import TileWrapper from '../TileWrapper'

// import { useTeam } from 'app/frontend/base/config/context/team'

const GuildMessageTile = () => {
  // const { guild } = useTeam()

  return (
    <TileWrapper>
      <p className='text-muted-foreground whitespace-pre-wrap'>{'-'}</p>
    </TileWrapper>
  )
}

export default GuildMessageTile
